/**
 * Created by Ning Jiang on 12/6/2018.
 */

import {FullScreenClicker} from "@nolimitcity/slot-game/bin/core/component/FullScreenClicker";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombstoneGameConfig} from "../TombstoneGameConfig";

export class ShootingGameView extends FullScreenClicker {

    private _holeContainer:PIXI.Container;
    private _holesPool:PIXI.Sprite[];

    constructor(onClickCallback:(e:PIXI.InteractionEvent | undefined) => void) {
        super(onClickCallback, TombstoneGameConfig.instance.LAYERS.SHOOTING_GAME.name);

        this._holesPool = [];
    }

    protected initAnimations():void {
        super.initAnimations();

        this._holeContainer = new PIXI.Container();
        this.addChild(this._holeContainer);
        this._layer.addChild(this);;
    }

    public shotAt(globalPosition:PIXI.Point):void {
        const windowHole:PIXI.Sprite = this.getHole();

        windowHole.position.set(globalPosition.x, globalPosition.y);
        this._holeContainer.addChild(windowHole);
    }

    private getHole():PIXI.Sprite {
        if(this._holesPool.length > 0) {
            return this._holesPool.pop()!;
        }

        const windowHold:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("windowHole")[0]); //bulletHole
        windowHold.anchor.set(0.5);
        return windowHold;
    }

    public clear():void {
        while(this._holeContainer.children.length > 0) {
            this._holesPool.push(<PIXI.Sprite>this._holeContainer.children.pop()!);
        }
    }
}